<template>
  <div class="cp-progress-main">
    <div class="cp-progress-bg" :style="{ 'border-radius': bRadius + 'px' }">
      <div class="cp-progress-bg1"></div>
      <div
        class="cp-progress-bar"
        :style="{
          width: getPercentage + '%',
          height: strokeWidth + 'px',
          'border-radius': bRadius + 'px',
        }"
        v-if="getPercentage != 0"
      >
        <div
          class="cp-progress-text"
          :style="{ 'line-height': strokeWidth + 16 + 'px' }"
        >
          {{ getPercentage }}%
        </div>
      </div>
      <div class="cp-progress-bar2" v-if="getPercentage != 0"></div>
      <!-- background: getGradient, -->
      <div
        class="cp-progress-bar1"
        :style="{
          width: getPercentage1 + '%',
          height: strokeWidth + 'px',
          'border-radius': bRadius + 'px',
          'margin-left': percentage == 0 ? '0' : '-10px',
        }"
        v-if="getPercentage1 != 0"
      >
        <div
          class="cp-progress-text1"
          :style="{ 'line-height': strokeWidth + 16 + 'px' }"
        >
          {{ getPercentage1 }}%
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      color: "transparent",
      color1: "transparent",
    };
  },
  computed: {
    // 通过比例 获取 百分比
    getPercentage() {
      if (this.percentage < 0) {
        return 0;
      } else if (this.percentage > 1) {
        return 100;
      } else {
        // console.log(this.percentage)
        return parseInt((this.percentage + 0.000006) * 100);
      }
    },
    getPercentage1() {
      if (this.percentage1 < 0) {
        return 0;
      } else if (this.percentage1 > 1) {
        return 100;
      } else {
        // console.log(this.percentage)
        return parseInt((this.percentage1 + 0.000006) * 100);
      }
    },
    // 获取 进度条颜色对象
    getGradient() {
      let linecolor = this.getColorItem(this.percentage);
      if (linecolor) {
        return "linear-gradient(90deg," + linecolor.s + "," + linecolor.e + ")";
      } else {
        return "";
      }
    },
  },
  methods: {
    // 根据进度 获取颜色数组
    getColorItem(p) {
      let mp = this.getPercentage;
      for (let sub of this.linearColors) {
        if (!sub.ef && mp <= sub.v) {
          return sub;
        } else if (sub.ef && mp < sub.v) {
          return sub;
        }
      }
      return null;
    },
  },

  props: {
    // 设置 进度条的 弧度
    bRadius: {
      type: Number,
      default: 4,
    },
    textInside: {
      type: Number,
      default: 100,
    },
    // 进度条的高度 就是粗细度
    strokeWidth: {
      type: Number,
      default: 28,
    },
    // 进度条 的百分比 [0-1] 的小数
    percentage: {
      type: Number,
      default: 0,
    },
    percentage1: {
      type: Number,
      default: 0,
    },
    // 进度条 每个阶段的 颜色组
    linearColors: {
      type: Array,
      default: function () {
        return [
          { v: 25, s: "#F7564A", e: "#F7564A" },
          { v: 50, s: "#F7564A", e: "#F7E04B" },
          { v: 100, s: "#F7E04B", e: "#25CCDB", ef: true },
          { v: 100, s: "#25CCDB", e: "#25CCDB" },
          // { v: 25, s: "#F7564A", e: "#F7564A" },
          // { v: 50, s: "#F7564A", e: "#F7E04B" },
          // { v: 100, s: "#F7E04B", e: "#25CCDB", ef: true },
          // { v: 100, s: "#25CCDB", e: "#25CCDB" },
        ];
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.cp-progress-main {
  display: flex;
  position: relative;
  height: 38px;
  // width: 90%;
  width: 700px;

  .cp-progress-bg {
    z-index: 999;
    width: 700px;

    flex: 1;
    margin: 8px 0;
    padding: 4px;
    display: flex;
    position: relative;
    align-items: center;
    .cp-progress-bg1 {
      position: absolute;
      z-index: -1;
      width: 690px;
      border-top: 36px solid #22308c;
      border-right: 20px solid transparent;
      line-height: 36px;
      height: 0;
      left: -3px;
    }
    .cp-progress-bar {
      width: 0;
      transition: width 1s ease-in;
      background: linear-gradient(88deg, #337af3, #00ffc8);
      display: flex;
      align-items: center;
      position: relative;
    }
    // .cp-progress-bar::after {
    //   content: " ";
    //   position: absolute;
    //   top: -36px;
    //   right: 8px;
    //   border-width: 32px 8px;
    //   border-style: solid;
    //   border-color: transparent transparent#22308c transparent;
    // }
    .cp-progress-bar2 {
      width: 14px;
      height: 28px;
      transform: skew(-30deg);
      background: #22308c;
      margin-left: -7px;
      z-index: 100;
    }
    .cp-progress-bar1 {
      width: 0;
      // animation: fadeInRight 5s ease;
      // transition: width 1s ease-in;
      background: linear-gradient(266deg, #d44889, #e9aeb9);
      display: flex;
      align-items: center;
      justify-content: flex-end;
      position: relative;
      transform: skew(-30deg);
      margin-left: -10px;
    }
    // .cp-progress-bar1::after {
    //   content: " ";
    //   position: absolute;
    //   top: 0;
    //   right: -6px;
    //   border-width: 28px 7px;
    //   border-style: solid;
    //   border-color: #d44889 transparent transparent transparent;
    // }
    // .cp-progress-bar1::before {
    //   content: " ";
    //   position: absolute;
    //   top: 0;
    //   left: -6px;
    //   z-index: 99;
    //   border-width: 32px 7px;
    //   border-style: solid;
    //   border-color: #22308c transparent transparent transparent;
    // }
  }

  // .cp-progress-bg::after {
  //   content: " ";
  //   position: absolute;
  //   top: 0;
  //   right: -15px;
  //   border-width: 36px 18px;
  //   border-style: solid;
  //   border-color: #22308c transparent transparent transparent;
  // }
  // .cp-progress-bg::before {
  //   content: " ";
  //   position: absolute;
  //   top: -38px;
  //   right: -0px;
  //   border-width: 36px 18px;
  //   border-style: solid;
  //   border-color: transparent transparent #22308c transparent;
  // }
  .cp-progress-text {
    font-size: 20px;
    font-family: SourceHanSansSC-Bold;
    font-weight: bold;
    color: #ffffff;
    margin-left: 5px;
  }

  .cp-progress-text1 {
    font-size: 20px;
    font-family: SourceHanSansSC-Bold;
    font-weight: bold;
    color: #ffffff;
    margin-right: 10px;
    transform: skew(30deg);
  }
}

/*从右到左进入*/
@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate(1000px, 0);
    transform: stranslate(1000px, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate(10px, 0);
    transform: stranslate(10px, 0);
  }
}

@-webkit-keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate(1000px, 0);
    transform: stranslate(1000px, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: translate(10px, 0);
    transform: stranslate(10px, 0);
  }
}
</style>